if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {
	/*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e)
	);

	$('.sym-slides').slick({
		accessibility: true,
	});

	if ($('.js-open-form-press').length > 0) {
		$('.js-open-form-press').click(function () {
			$('#form-press').toggle('slow');
		});
	}

	$('.wild-insight-entry__slider').slick({
		arrows: true,
		dots: false,
		infinite: true,
		fade: true,
		speed: 700,
		autoplaySpeed: 2000,
		accessibility: true,
		slidesToShow: 1,
		slide: '.insight-image',
		prevArrow: '.wild-insight-entry__prev',
		nextArrow: '.wild-insight-entry__next',
	});

	$('.events-entry__slider').slick({
		arrows: true,
		dots: false,
		infinite: true,
		fade: true,
		speed: 700,
		autoplaySpeed: 2000,
		accessibility: true,
	});

	$('.js-open-main-booking').click(function () {
		$('#select-booking').addClass('show');
	});

	$('.js-close-main-booking').click(function () {
		$('#select-booking').removeClass('show');
	});

	$('#personal_retreats').click(function () {
		//$('#booking-form').attr('action',booking_personal);
		$('.personal_retreats_label').addClass('active');
		$('.guided_retreats_label').removeClass('active');
		// window.location.href = 'https://reservations.travelclick.com/114654?LanguageID=1#/guestsandrooms';
		window.open('https://reservations.travelclick.com/114654?LanguageID=1#/guestsandrooms','_blank');
	});

	$('#guided_retreats').click(function () {
		//$('#booking-form').attr('action',booking_guided);
		$('.guided_retreats_label').addClass('active');
		$('.personal_retreats_label').removeClass('active');
		window.location.href = site_url + 'retreats-wisconsin';
		
	});

	$('#adults').val(2);
	$('#number_guest').text('2 ADULTS');


	if ($('.location-spots__slider').length > 0) {
		$('.location-spots__slider').slick({
			arrows: true,
			fade: true,
			infinite: false,
			autoplay: false,
			speed: 700,
			accessibility: true,
			slide: '.location-spots__slide',
			prevArrow: '.location-spots__prev',
			nextArrow: '.location-spots__next',
		});
		$('.location-spots__point').click(function () {
			let numSlide = $(this).data('spot');
			$('.location-spots__point').removeClass('active');
			$('.location-spots__slider').slick('slickGoTo', numSlide);
			$(this).addClass('active');
		});

		$('.location-spots__next').click(function () {
			let nextSlide = $('.slick-current').data('slick-index');
			$('.location-spots__point').removeClass('active');
			$('.location-spots__point.' + nextSlide).addClass('active');
		});

		$('.location-spots__prev').click(function () {
			let prevSlide = $('.slick-current').data('slick-index');
			$('.location-spots__point').removeClass('active');
			$('.location-spots__point.' + prevSlide).addClass('active');
		});
	}

	//SUBNAVIGATION

	// Open active sub-nav on load
	$('.navigation ul.submenu li .active').closest('.inner').addClass('open');
	$('.navigation ul.submenu li .active')
		.parents()
		.parents('li')
		.addClass('item-open');
	$('.navigation ul.submenu li .active')
		.closest('.sub-sub-menu')
		.slideDown(300, function () {})
		.addClass('menu-open');

	//Toggle open/close on tap
	$('.navigation li a')
		.off('click')
		.on('click', function (event) {
			if ($(this).parent().children('.sub-sub-menu').length > 0) {
				event.preventDefault();

				if ($(this).next().hasClass('menu-open')) {
					$(this).closest('.inner').removeClass('open');
					$('.navigation ul li').removeClass('item-open');
					$(this).parent().addClass('item-open');
					$(this)
						.next()
						.slideUp(300, function () {
							if ($('.navigation ul li a').hasClass('active')) {
								$('.item-open').get(0).scrollIntoView(false);
							}
						})
						.removeClass('menu-open');
				} else {
					$(this).closest('.inner').addClass('open');
					$('.navigation ul li').removeClass('item-open');
					$(this).parent().addClass('item-open');
					$('.sub-sub-menu.menu-open')
						.slideUp(300)
						.removeClass('menu-open');
					$(this)
						.next()
						.addClass('menu-open')
						.slideDown(300, function () {
							if ($('.navigation ul li a').hasClass('active')) {
								$('.item-open').get(0).scrollIntoView(false);
							}
						});
				}
			}
		});

	$('#open-menu-mobile').click(function () {
		$('.navigation.overlay').addClass('show');
	});

	$('.navigation.overlay .close-menu').click(function () {
		$('.navigation.overlay').removeClass('show');
	});

	$('.js-open-menu-tablet').click(function () {
		$('.menu-tablet').addClass('show');
	});

	$('.navigation.tablet-menu .close-menu').click(function () {
		$('.menu-tablet').removeClass('show');
	});

	$('.slider-columns__slider').slick({
		arrows: true,
		autoplay: false,
		autoplaySpeed: 6000,
		speed: 700,
		slidesToShow: 3,
		slide: '.slider-columns-slide',
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 500,
				settings: {
					arrows: false,
					slidesToShow: 1,
					centerMode: true,
					variableWidth: true,
				},
			},
		],
	});

	$('.btn-green').each(function (index, element) {
		var text_intro =
			'<span class="text__top">' +
			$(element).text() +
			'</span><span class="text__bottom">' +
			$(element).text() +
			'</span>';
		$(element).html(text_intro);
	});

	$('.btn-yellow').each(function (index, element) {
		var text_intro =
			'<span class="text__top">' +
			$(element).text() +
			'</span><span class="text__bottom">' +
			$(element).text() +
			'</span>';
		$(element).html(text_intro);
	});

	$('.btn-alt').each(function (index, element) {
		var text_intro =
			'<span class="text__top">' +
			$(element).text() +
			'</span><span class="text__bottom">' +
			$(element).text() +
			'</span>';
		$(element).html(text_intro);
	});

	$('button.btn').each(function (index, element) {
		var text_intro =
			'<span class="text__top">' +
			$(element).text() +
			'</span><span class="text__bottom">' +
			$(element).text() +
			'</span>';
		$(element).html(text_intro);
	});

	$('button.signup-btn').each(function (index, element) {
		var text_intro =
			'<span class="text__top">' +
			$(element).text() +
			'</span><span class="text__bottom">' +
			$(element).text() +
			'</span>';
		$(element).html(text_intro);
	});

	//Loading preload
	if (document.getElementById('home')) {
		//document.onreadystatechange = function () { 
			//if (document.readyState === 'complete') {
				setTimeout(function () {
					// console.log(document.readyState);
					document.documentElement.scrollTop = 0;
					document
						.getElementById('preloader-home')
						.classList.add('hide');
					document
						.getElementById('preloader-overlay')
						.classList.add('hide');
					document
						.getElementById('fake-content')
						.classList.add('hide');
				}, 2000);
				setTimeout(function () {
					$('.top-content__icon img').attr('src', linkImage);
					$('.top-content__icon img').attr('alt', altImage);
					//window.scroll(0,10);
				}, 3000);
			//}
		//};
	}

	if (document.getElementById('events-entry')) {
		$('.events-entry__tabs ul li').click(function () {
			const thisTag = $(this).attr('data-tag');
			$('.events-entry__content-tab').hide();
			$('.events-entry__content-tab.' + thisTag).fadeIn('slow');
			$('.events-entry__tabs ul li').removeClass('active');
			$(this).addClass('active');
		});
		const filter_tab = document.querySelectorAll(
			'.events-entry__tabs ul li'
		);
		filter_tab[0].click();
	}

	if ($('.calendar-grid').length > 0) {
		let finalTags = [],
			tags = [],
			years = [],
			months = [],
			years_months = [],
			years_months1 = [],
			years_months2 = [],
			optionYear = null,
			monthNames = [
				'january',
				'february',
				'march',
				'april',
				'may',
				'june',
				'july',
				'august',
				'september',
				'october',
				'november',
				'december',
			],
			today = new Date();

		$('.calendar-grid__filters .each-checbox input').click(function (e) {
			const idName = $(this).parents().eq(2).attr('id');
			if ($(this).prop('checked') && $(this).is(':checkbox')) {
				if (idName == 'select_month') {
					months.push($(this).attr('value'));
				} else tags.push($(this).attr('value'));
			} else if (!$(this).prop('checked') && $(this).is(':checkbox')) {
				//if(idName !== 'select_year'){
				const index = tags.indexOf($(this).attr('value'));
				if (index > -1) tags.splice(index, 1);
				const indexM = months.indexOf($(this).attr('value'));
				if (indexM > -1) months.splice(indexM, 1);
				//}
			} else {
				if (idName == 'select_year') {
					years = [];
					years_months1 = [];
					if ('pa_events' == $(this).attr('value')) {
						optionYear = -1;
						for (let i = 1; i < 24; i++) {
							let pastDate = new Date(
								new Date().getFullYear(),
								new Date().getMonth() - i,
								new Date().getDate()
							);
							years_months1.push(
								pastDate.getFullYear() +
									' ' +
									pastDate
										.toLocaleString('en-US', {
											month: 'long',
										})
										.toLowerCase()
							);
							years.push(pastDate.getFullYear());
						}
					} else if ('up_events' == $(this).attr('value')) {
						optionYear = 1;
						for (let i = 0; i < 24; i++) {
							let dayC =
								new Date().getDate() == 31 ||
								(new Date().getDate() == 28 &&
									new Date().getMonth() + i == 1)
									? '01'
									: new Date().getDate();
							let futureDate = new Date(
								new Date().getFullYear(),
								new Date().getMonth() + i,
								dayC
							);
							years_months1.push(
								futureDate.getFullYear() +
									' ' +
									futureDate
										.toLocaleString('en-US', {
											month: 'long',
										})
										.toLowerCase()
							);
							years.push(futureDate.getFullYear());
						}
					}
				}
			}

			years = [...new Set(years)];
			months = [...new Set(months)];

			if (months.length > 0) {
				years_months2 = [];
				//concat years and months
				years.forEach((year) => {
					months.forEach((month) => {
						let nextMonth =
								monthNames.indexOf(month) == 11
									? 0
									: monthNames.indexOf(month) + 1,
							instDate = new Date(year, nextMonth, 1);
						if (optionYear == 1) {
							if (today.getTime() < instDate.getTime())
								years_months2.push(`${year} ${month}`);
						} else {
							years_months2.push(`${year} ${month}`);
						}
					});
				});
				if (years.length == 0) {
					years_months2 = [...months];
				}
			} else {
				years_months2 = [];
			}

			if (years_months2.length > 0)
				years_months = [...new Set(years_months2)];
			else years_months = [...new Set(years_months1)];

			finalTags = [...tags];
			finalTags = [...new Set(finalTags)];
			let items = document.querySelectorAll('.calendar-grid__item');
			items.forEach((item) => {
				if (years_months.length == 0) item.classList.add('active');
				else {
					item.classList.remove('active');
					years_months.filter((tag) => {
						let eventDate = new Date(item.dataset.date);

						if (
							item.dataset.tag.indexOf(tag) > -1 &&
							optionYear == 1 &&
							eventDate.getTime() >= today.getTime()
						)
							item.classList.add('active');
						else if (
							months.length == 0 &&
							optionYear == -1 &&
							(item.dataset.tag.indexOf(tag) > -1 ||
								eventDate.getTime() < today.getTime())
						)
							item.classList.add('active');
						else if (
							item.dataset.tag.indexOf(tag) > -1 &&
							optionYear == -1
						) {
							item.classList.add('active');
						}
					});
				}
			});

			items = document.querySelectorAll('.calendar-grid__item.active');
			items.forEach((item) => {
				if (finalTags.length > 0) {
					item.classList.remove('active');
					finalTags.filter((tag) => {
						// console.log(2);
						if (item.dataset.tag.indexOf(tag) > -1)
							item.classList.add('active');
					});
				}
			});

			//console.log('finalTags:',finalTags,'YM:',years_months,"Years:",years,"Months:",months);

			if ($('.calendar-grid__item.active').length > 0) {
				$('.calendar-grid__no-info').removeClass('active');
			} else {
				$('.calendar-grid__no-info').addClass('active');
			}
		});
		$('#reset-events').click(function () {
			$('.calendar-grid__item').addClass('active');
			$('.calendar-grid__filters .each-checbox input').prop(
				'checked',
				false
			);
			(finalTags = []),
				(tags = []),
				(years = []),
				(months = []),
				(years_months = []),
				(years_months1 = []),
				(years_months2 = []),
				(optionYear = 1);
		});

		$('.dropdown__list-years input:radio:first').trigger('click');
	}

	$('.scroll-link').click(function () {
		var target = $(this).attr('href');
		$('html, body').animate(
			{ scrollTop: $(target).offset().top - 120 },
			1000
		);
		return false;
	});

	$('.gallery-landing__slider').slick({
		arrows: false,
		dots: false,
		autoplay: true,
		autoplaySpeed: 6000,
		speed: 600,
		slidesToShow: 1,
		infinite: true,
		variableWidth: true,
		centerMode: true,
		responsive: [
			{
				breakpoint: 600,
				settings: {
					arrows: true,
					variableWidth: false,
					centerMode: false,
				},
			},
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
		],
	});

	if ($('.posts-tabs .posts-tabs__tabs').length > 0) {
		$('.posts-tabs__tabs li').click(function () {
			const thisTag = $(this).attr('data-tab');
			$('.posts-tabs__text .box-text').hide();
			$('.posts-tabs__images img').hide();
			$('.posts-tabs__text .box-text.' + thisTag).fadeIn();
			$('.posts-tabs__images img.' + thisTag).fadeIn();
			$('.posts-tabs__tabs li').removeClass('active');
			$(this).addClass('active');
		});
		const tab = document.querySelectorAll('.posts-tabs__tabs li');
		tab[0].click();
	}

	if (document.getElementById('icon-dots')) {
		var svgContainer = document.getElementById('icon-dots');
		var animItem = lottie.loadAnimation({
			wrapper: svgContainer,
			animType: 'svg',
			loop: false,
			path: 'icon-dots-3.json',
		});
	}

	if (document.getElementById('icon-geometric')) {
		var svgContainer = document.getElementById('icon-geometric');
		var animItem = lottie.loadAnimation({
			wrapper: svgContainer,
			animType: 'svg',
			loop: false,
			path: 'icon-geometric-3.json',
		});
	}

	if (document.getElementById('icon-map')) {
		var svgContainer = document.getElementById('icon-map');
		var animItem = lottie.loadAnimation({
			wrapper: svgContainer,
			animType: 'svg',
			loop: false,
			path: 'icon-map-3.json',
		});
	}

	if (document.getElementById('icon-waves')) {
		var svgContainer = document.getElementById('icon-waves');
		var animItem = lottie.loadAnimation({
			wrapper: svgContainer,
			animType: 'svg',
			loop: false,
			path: 'icon-waves-3.json',
		});
	}

	$('.js-open-form-press').click(function () {
		$('.press-form-content').toggle('show');
	});

	// if(document.getElementById('quad-bg-two-imgs-content-border')){
	//     var svgContainer = document.getElementById('quad-bg-two-imgs-content-border');
	//     var animItem = lottie.loadAnimation({
	//         wrapper: svgContainer,
	//         animType: 'svg',
	//         loop: false,
	//         path: 'border.json'
	//     });
	// }

	/* FORMS SUBMIT BTN ARIA LABEL */

	(function () {	
		if (document.getElementById('form_id-2915')) {
			var submitbtn = document.getElementById("form_id-2915").querySelector(" .btn");
			submitbtn.setAttribute('aria-label', 'submit teaching proposal');
		}

		if (document.getElementsByClassName('footer')) {
			var submitbtn = document.getElementById("email-signup").querySelector(" .signup-btn");
			submitbtn.setAttribute('aria-label', 'subscribe to our email database');
		}
	})()



	/*PAGE SCROLL FUNCTIONALITY*/

	function scrollElementByQuadParam(url) {
		const parsedURL = new URL(url);
		const quadValue = parsedURL.searchParams.get("quad");
	
		if (quadValue) {
			const elementToScroll = document.getElementById(quadValue);
	
			if (elementToScroll) {
				const scrollToPosition = elementToScroll.getBoundingClientRect().top - 100;
	
				// Scroll to the calculated position
				window.scrollTo({
					top: window.scrollY + scrollToPosition,
					behavior: "smooth"
				});

			} else {
				console.log("No element with the provided 'quad' parameter value was found.");
			}
		} else {
			console.log("The 'quad' parameter is not present in the URL.");
		}
	}

	scrollElementByQuadParam( window.location.href );
})();
